import React from 'react'
import { localizations } from '../config'

const Property = ({ subscriber, property, children, value }) => (
    <div className="property">
        <label>{localizations[property] || property}</label>
        <span>{children || value || subscriber[property] || '-'}</span>
    </div>
)

export default ({ subscriber, user }) => {
        const hasManagementIP = subscriber.management_ip && subscriber.management_ip.length > 0

        const unitRoles = user && user.roles && user.roles
            .filter(r => r.unit && subscriber.unit_id && (`${r.unit}`.toLowerCase() === `${subscriber.unit_id}`.toLowerCase()))
            .map(r => r.role && `${r.role}`.toLowerCase())

        const isUnitAdmin = unitRoles && (~unitRoles.indexOf('admin') || ~unitRoles.indexOf('user'))

        const canManage = user.isGlobalAdmin || isUnitAdmin

    return (
    <div className="detail-pane">
        <Property {...{ subscriber }} property="description" />
        <Property {...{ subscriber }} property="device" />
        <Property {...{ subscriber }} property="site_name" />
        <Property {...{ subscriber }} property="room_rack" />
        <Property {...{ subscriber }} property="switch_port" />
        <Property {...{ subscriber }} property="management_ip_ssl">{subscriber.management_ip_ssl > 0 ? 'yes' : 'no'}</Property>
        <Property {...{ subscriber }} property="supported_algorithms" />
        <Property {...{ subscriber }} property="ip">
            {subscriber.ip || '-'}
            {!hasManagementIP && canManage && subscriber.ip && [1, 2, 3, 4, 5].map(i =>
                <a href={`/codec.html?session=${i}&username=${subscriber.username}`} className="codec-webgui" target={`webgui_session_${i}`} title={`Session ${i}`}>[C{i}]</a>
            )}
        </Property>
        <Property {...{ subscriber }} property="codec" />
        <Property {...{ subscriber }} property="management_ip">
            {(hasManagementIP && subscriber.management_ip) || '-'}
            {hasManagementIP && canManage && [1, 2, 3, 4, 5].map(i =>
                <a href={`/codec.html?session=${i}&username=${subscriber.username}`} className="codec-webgui" target={`webgui_session_${i}`} title={`Session ${i}`}>[C{i}]</a>
            )}
        </Property>
        <Property {...{ subscriber }} property="did" value={subscriber.did && subscriber.did.replace(/\+[0-9]{11}/, m => `${m.substr(0, 3)} ${m.substr(3, 2)} ${m.substr(5, 3)} ${m.substr(8, 2)} ${m.substr(10, 2)} `)} />

        {(subscriber.created || subscriber.createdby) &&
            <div className="small">
                Created{subscriber.createdby && (<span> by '{subscriber.createdby}'</span>)}<span> {subscriber.created}</span>
            </div>
        }

        {(subscriber.modified || subscriber.modifiedby) &&
            <div className="small">
                Modified {subscriber.modifiedby && (<span> by '{subscriber.modifiedby}'</span>)} <span> {subscriber.modified}</span>
            </div>
        }
    </div>
)}


// WEBPACK FOOTER //
// ./components/SubscriberDetailPane.jsx